module.exports = __webpack_public_path__ + "img/subscribe.52731130.svg";